import {
  ControlledTooltip,
  ControlledTooltipBody,
  ControlledTooltipTitle,
} from 'components/DtiRadialMeter/ControlledTooltip'

export const TooltipMonthlyIncome = () => {
  const componentTitle = <ControlledTooltipTitle>Monthly gross income</ControlledTooltipTitle>

  const componentBody = (
    <ControlledTooltipBody>
      <>
        Add up all your monthly income (before tax) from:
        <ul>
          <li>salary & earned income</li>
          <li>pension & social security </li>
          <li>monthly earnings from investments & savings</li>
          <li>other income (child support, alimony, etc.)</li>
        </ul>
      </>
    </ControlledTooltipBody>
  )

  return <ControlledTooltip modalTitle={componentTitle} modalBody={componentBody} />
}
